<!-- LanguageSwitcher.vue -->
<script setup>
import { ref, onMounted } from 'vue'
import { NDropdown } from 'naive-ui'
import { LANGUAGES, getPreferredLanguage, savePreferredLanguage, getLanguageLabel } from '@/services/language'

const currentLanguage = ref(getPreferredLanguage() || 'english')

const options = LANGUAGES.map(lang => ({
  label: lang.label,
  key: lang.value
}))

const handleSelect = (key) => {
  currentLanguage.value = key
  savePreferredLanguage(key)
  // Optional: Reload the page or re-fetch data in the new language
}
</script>

<template>
  <div class="language-switcher">
    <NDropdown
      :options="options"
      :value="currentLanguage"
      @select="handleSelect"
      trigger="click"
    >
      <div class="language-display">
        <span class="language-icon">🌐</span>
        <span class="language-name">{{ getLanguageLabel(currentLanguage) }}</span>
      </div>
    </NDropdown>
  </div>
</template>

<style scoped>
.language-switcher {
  cursor: pointer;
}

.language-display {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.5rem;
  border-radius: 4px;
  transition: background-color 0.2s;
}

.language-display:hover {
  background-color: rgba(0, 0, 0, 0.05);
}

.language-icon {
  font-size: 1.2rem;
}
</style>